import React, { useRef, useState, useEffect } from "react";
import "./TargetClients.css";

const clients = [
    "Small businesses",
    "Condo/property management companies",
    "Local service businesses",
    "Schools or education organizations",
    "Professional offices"
];

export default function TargetClients() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !isVisible) {
                setIsVisible(true);
            }
        });
        if (targetRef.current) observer.observe(targetRef.current);
    }, [isVisible]);

    const className = "TargetClients hidden " + (isVisible ? "show" : "");

    return (
        <section ref={targetRef} className={className} id="who-we-help">
            <h2 className="title">Who We Help</h2>
            <p className="section-description">
                We work best with businesses that are using messy spreadsheets, paper files, manual admin processes, or outdated websites, and want a better way to work.
            </p>
            <ul className="client-list">
                {clients.map((client, index) => (
                    <li key={index} className="client-item">
                        {client}
                    </li>
                ))}
            </ul>
        </section>
    );
}
